import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { createElement, memo } from '@max/max';
import '../../../index.scss';
import '../calendar.scss';
const CalendarHeader = () => {
    return <View className="calendar-days-header-container">
      <Text className="calendar-days-header-item calendar-days-header-hightlight">日</Text>
      <Text className="calendar-days-header-item">一</Text>
      <Text className="calendar-days-header-item">二</Text>
      <Text className="calendar-days-header-item">三</Text>
      <Text className="calendar-days-header-item">四</Text>
      <Text className="calendar-days-header-item">五</Text>
      <Text className="calendar-days-header-item calendar-days-header-hightlight">六</Text>
    </View>;
};
export default memo(CalendarHeader);
